import { render, staticRenderFns } from "./DownloadOrdersModal.vue?vue&type=template&id=0af15e58&"
import script from "./DownloadOrdersModal.vue?vue&type=script&lang=js&"
export * from "./DownloadOrdersModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports